export default {
  header: {
    title: 'Comprar cartão de oferta',
  },
  items: {
    gift_card: {
      label: 'Cartão de oferta',
      title: 'Selecione o valor pretendido',
      description: 'Adicione o cartão de oferta com a quantidade pretendida ao carrinho',
    },
    expiration: {
      label: 'Válido por 3 anos',
      title: 'Bom presente!',
      description: 'O destinatário pode resgatar o voucher de forma flexível no prazo de 3 anos.',
    },
    delivery: {
      label: 'Entrega imediata em PDF por e-mail',
      title: 'Entrega instantânea em PDF por e-mail',
      description: 'Após pagamento seguro por cartão de crédito, PayPal ou giropay, receberá o voucher imediatamente.',
    },
  },
  form: {
    value: {
      title: 'Escolha o valor do cartão de oferta',
      custom: {
        label: 'Personalizado',
        placeholder: 'Introduza o valor',
      },
    },
    quantity: {
      title: 'Quantidade',
    },
    email: {
      title: 'Qual é o seu endereço de e-mail para enviarmos o cartão de oferta?',
      placeholder: 'O seu endereço de e-mail',
    },
  },
  confirmation: {
    title: {
      title: 'Criar cartão de oferta?',
      subtitle_one: 'Deseja criar 1 cartão de oferta no valor de {{value}}?',
      subtitle_other: 'Deseja criar {{count}} cartões de oferta no valor de {{value}}?',
    },
    description: {
      total: 'Total:',
      email: 'E-Mail:',
      quantity: 'Quantidade',
      amount: 'Valor',
    },
    footer: {
      cancel: 'Cancelar',
      confirm: 'Confirmar',
    },
  },
  buttons: {
    create: 'Criar',
  },
  toasts: {
    error: 'Falha ao criar cartão de oferta.',
    success: 'Cartão de oferta criado com sucesso.',
  },
};
